<template>
	<AppHeader :header="page" />
</template>
<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useThemeStore } from '@/stores/useThemeStore';
import AppHeader from '@/components/AppHeader.vue';

const themeStore = useThemeStore();

const { theme } = storeToRefs(themeStore);

const page = computed(() => theme.value.pages.header);
</script>